@let isLocating = arcgisLocate.state === 'locating';
@let label = isLocating ? 'Finner din posisjon. Klikk for å avbryte' : 'Se posisjonen din';

<button
  type="button"
  class="e-btn e-btn--icon touch-action-manipulation"
  [class.e-btn--loading]="isLocating"
  [aria-label]="label"
  [attr.title]="label"
  [aria-busy]="isLocating"
  (click)="toggleLocate()">
  @if (isLocating) {
    <span></span>
    <span></span>
    <span></span>
  } @else {
    <span class="e-btn__icon">
      <e-icon name="positionBold" />
    </span>
  }
</button>

<arcgis-locate
  #arcgisLocate
  reference-element="map"
  popup-disabled
  class="e-none"
  (arcgisPropertyChange)="onArcgisPropertyChange()"
  (arcgisSuccess)="onArcgisSuccess()"
  (arcgisError)="onArcgisError()" />
